// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import directive from './directive'
import '@/assets/font/iconfont.js'
import Icon from '@/components/icon/Icon'
import Tips from '@/components/tips/Tips'
import filters from '@/filters/index'
import echarts from 'echarts'

import './permission' // permission control

import db from '@/utils/db.js'
Vue.prototype.$db = db;

Vue.prototype.$echarts = echarts

Vue.component('Icon', Icon)
Vue.component('GmTips', Tips)
Vue.use(ElementUI)

for(let key in filters){
	Vue.filter(key,filters[key]);
}
Vue.prototype.$filter = filters;

Vue.config.productionTip = false

Vue.directive('search', {
  // 只要更新就会触发钩子函数
  update(el,binding){
    var {searchValue,message}=binding.value;
    // 将字符串转数组
    var arr = message.split(searchValue)
    // 将searchValue标红
    var sp = `<span style="color:red;">${searchValue}</span>`;
    //使用红色的字对数组进行连接，连接后放回到 el中
    el.innerHTML = arr.join(sp);
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js